module.exports = __webpack_public_path__ + "img/img.b9add968.png";